<script>
import Vue from 'vue'

export default {
  name: 'ModalProfilePicture',
  data() {
    return {
      busModal: new Vue(),
      imageUrl: '',
      name: '',
    }
  },
  methods: {
    clear() {
      this.imageUrl = ''
      this.name = ''
    },
    open({ imageUrl, name } = {}) {
      this.clear()
      if (!imageUrl) return
      this.imageUrl = imageUrl
      this.name = name || ''
      this.busModal.$emit('dialog', true)
    },
    close() {
      this.busModal.$emit('dialog', false)
    },
  },
}
</script>

<template>
  <BaseModal
    centerScreen
    :bus="busModal"
    persistent
    centerAndDecreasesPadding
    maxWidth="500px"
    closeColor="#8e8e8e"
    backgroundColor="white"
    content-class="atendimento-inner-modal"
  >
    <div class="pb-6">
      <div class="modal-title-container">
        <span class="modal-title">{{ name || 'Foto do contato' }}</span>
      </div>

      <div class="modal-content">
        <div
          class="profile-picture-body d-flex justify-center align-center pa-4"
        >
          <img :src="imageUrl" :alt="name" class="profile-picture-image" />
        </div>
      </div>
    </div>

    <template v-slot:actions>
      <BaseButton underlined @click="close"> Fechar </BaseButton>
    </template>
  </BaseModal>
</template>

<style lang="sass" scoped>
.profile-picture-image
  max-width: 100%
  max-height: 60vh
  border-radius: 4px
  object-fit: contain
</style>
